module.exports = __webpack_public_path__ + "static/media/search.d9672ed6.svg";